import { VISIT_CANCEL_REASON_OPTIONS } from './cancelReasons';

type Props = {
  name: string;
  labelledBy: string;
  value: string;
  disabled?: boolean;
  onChange: (code: string) => void;
};

/** In-dialog choices. A native select popup is drawn outside the dialog, so mouse clicks miss the options. */
export function VisitCancelReasonPicker({ name, labelledBy, value, disabled, onChange }: Props) {
  return (
    <div className="visit-cancel-reasons" role="radiogroup" aria-labelledby={labelledBy}>
      {VISIT_CANCEL_REASON_OPTIONS.map((option) => {
        const selected = value === option.code;
        return (
          <label
            key={option.code}
            className={`visit-cancel-reasons__option${selected ? ' is-selected' : ''}`}
          >
            <input
              type="radio"
              name={name}
              value={option.code}
              checked={selected}
              disabled={disabled}
              onChange={() => onChange(option.code)}
            />
            <span>{option.label}</span>
          </label>
        );
      })}
    </div>
  );
}
